import { DefaultToastOptions } from "react-hot-toast"
import { AxiosRequestConfig } from "axios"

import { API_URL } from "@src/config/environments"

// API Configuration
export const API_CONFIG = {
  BASE_URL: API_URL,
  TIMEOUT: 10000,
}

// App Configuration
export const APP_CONFIG = {
  NAME: "Legacy AI",
  VERSION: "1.0.0",
  DESCRIPTION: "Preserve your digital legacy forever",
}

// Question Categories
export const QUESTION_CATEGORIES: IGenericOption[] = [
  // { value: "personal", label: "Personal", icon: "👤" },
  // { value: "family", label: "Family", icon: "👨‍👩‍👧‍👦" },
  // { value: "career", label: "Career", icon: "💼" },
  // { value: "hobbies", label: "Hobbies", icon: "🎨" },
  // { value: "beliefs", label: "Beliefs", icon: "🙏" },
  // { value: "memories", label: "Memories", icon: "📸" },
  // { value: "wisdom", label: "Wisdom", icon: "🧠" },
  // { value: "humor", label: "Humor", icon: "😄" },
  // { value: "values", label: "Values", icon: "💎" },
  // { value: "experiences", label: "Experiences", icon: "🌟" },
  // agreeableness, conscientiousness, extraversion, neuroticism, openness
  { value: "agreeableness", label: "🤝 Agreeableness" },
  { value: "conscientiousness", label: "💪 Conscientiousness" },
  { value: "extraversion", label: "👥 Extraversion" },
  { value: "neuroticism", label: "😰 Neuroticism" },
  { value: "openness", label: "🌍 Openness" },
]

// Message Types
export const MESSAGE_TYPES = [
  { value: "letter", label: "Letter", icon: "📝" },
  { value: "video_message", label: "Video Message", icon: "🎥" },
  { value: "audio_message", label: "Audio Message", icon: "🎵" },
  { value: "birthday", label: "Birthday", icon: "🎂" },
  { value: "anniversary", label: "Anniversary", icon: "💍" },
  { value: "special_occasion", label: "Special Occasion", icon: "🎉" },
]

// Conversation Types
export const CONVERSATION_TYPES = [
  { value: "text", label: "Text", icon: "💬" },
  { value: "audio", label: "Audio", icon: "🎤" },
  { value: "video", label: "Video", icon: "📹" },
]

// File Upload Limits
export const FILE_LIMITS = {
  IMAGE: {
    MAX_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_TYPES: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  },
  AUDIO: {
    MAX_SIZE: 50 * 1024 * 1024, // 50MB
    ALLOWED_TYPES: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/mp4"],
  },
  VIDEO: {
    MAX_SIZE: 200 * 1024 * 1024, // 200MB
    ALLOWED_TYPES: ["video/mp4", "video/webm", "video/ogg"],
  },
}

// Validation Rules
export const VALIDATION_RULES = {
  PASSWORD: {
    MIN_LENGTH: 8,
    REQUIRE_UPPERCASE: true,
    REQUIRE_LOWERCASE: true,
    REQUIRE_NUMBER: true,
    REQUIRE_SPECIAL: false,
  },
  EMAIL: {
    PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  NAME: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
  },
}

// Animation Durations
export const ANIMATION_DURATION = {
  FAST: 0.2,
  NORMAL: 0.3,
  SLOW: 0.5,
  VERY_SLOW: 0.8,
}

// Breakpoints
export const BREAKPOINTS = {
  SM: "640px",
  MD: "768px",
  LG: "1024px",
  XL: "1280px",
  "2XL": "1536px",
}

export const globalToastOptions: DefaultToastOptions = {
  duration: 4000,
  style: {
    background: "#363636",
    color: "#fff",
  },
  success: {
    duration: 3000,
    iconTheme: {
      primary: "#4ade80",
      secondary: "#fff",
    },
  },
  error: {
    duration: 5000,
    iconTheme: {
      primary: "#ef4444",
      secondary: "#fff",
    },
  },
}

export const configMedia: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
}

export const URL_STORAGE = "https://go2storage.s3.us-east-2.amazonaws.com/" // "https://backend.t4ever.com/storage/"

export const STORAGE_KEYS = {
  CURRENT_PROFILE: "t4ever-current-profile",
  THEME: "t4ever-theme",
  AUTH: "t4ever-auth",
}

export const DATE_FORMATS = {
  DATE: "MMM DD, YYYY",
  DATE_TIME: "MMM DD, YYYY hh:mm A",
}
